import axios from "axios";
import { ICustomer, ILegalEntity } from "../../types";

export interface IGetCompanyParams {
    companyId: string;
    firstInvoiceRecipient: string;
    creditType: string;
}

export interface IGetOwnerCompanyResponse {
    bookingOwner: ICompany;
    billingOwner: ICompany;
    bookingOwnerPerson: ICustomer;
    billingOwnerPerson: ICustomer;
}

export interface ICompany {
    customerId: string;
    sapId: string;
    companyName: string | null;
    vatNumber: string | null;
    vatNumberCountry: string | null;
    fiscalCode: string | null;
    siren: string | null;
    siret: string | null;
    country: string | null;
    city: string | null;
    streetName: string | null;
    streetNumber: string | null;
    postalCode: string | null;
    certifiedEmail: string | null;
    email: string | null;
    invoiceCode: string | null;
    uuid: string;
    telephone: string | null;
    mobile: string | null;
    mobilePrefix: string | null;
    province: string | null;
    linkedToBusinessAgreement: boolean;
    legalEntity: ILegalEntity | null;
    publicAuthority: string;
    paIdNumber: string;
}

export const getCompanyData = async (params: IGetCompanyParams): Promise<IGetOwnerCompanyResponse> => {
    const response = await axios.get('/booking/instool/getCompany', {
        params
    });
    return response.data;
};
